export const phoneRegex = /^(?:[0-9] ?){6,14}[0-9]$/